jQuery(function ($) {
    //スムーススクロール
    var headerHight = 0;
    $('a[href^="#"]').on('click', function () {
        var href = $(this).attr('href');
        var target;
        if (href == '#' || href == '') {
          target = $('html');
        } else {
          target = $(href);
        }
        var posi = target.offset().top - headerHight;
        $('html,body').animate({
          'scrollTop': posi
        }, 500);
        return false;
    });

    //プログレスバー
    $('.program__progress-bar').on('inview', function(event, isInView){
      if (isInView) {
        let width_var = $(this).attr('data-width');
        if ( width_var > 2 ) {
          $(this).css('width',width_var + '%');
        }
      }
    });

    //画像右クリック禁止
    $("img").on("contextmenu",function(){
      return false;
    });

    //要素が画面内にあるか判定
    function is_visible(target) {
        // スクロール位置を取得
        var scrollTop = $(window).scrollTop();
        var scrollBtm = scrollTop + $(window).height();

        // 対象要素の位置を取得
        var targetTop = target.offset().top;
        var targetBtm = targetTop + target.height();

        // 画面内にある場合
        if(scrollBtm > targetTop && scrollTop < targetBtm) {
            return true;
        } else {
            return false;
        }
    }
    window.util= window.util|| {};
    window.util.is_visible = is_visible;

});

window.addEventListener('load', function() {
    resizeViewport(true);
});
window.addEventListener('resize', function() {
    resizeViewport(false);
});
function resizeViewport(onload) {
    //375px未満の場合viewport再設定
    if (window.matchMedia( '(max-width: 374px)' ).matches) {
        let vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        let initialScale = vw / 375;
        let maximumScale = vw / 375;
        jQuery("head [name='viewport']").remove();
        jQuery('head').prepend('<meta name="viewport" content="width=375,initial-scale=' + initialScale + ',maximum-scale=' + maximumScale + '">');
        if ( onload ) {
            correctScrollTop();
        }
    }
}
function correctScrollTop() {
    if(window.location.hash == "") {
        window.setTimeout(function() {
            $("html, body").prop({scrollTop:0});
        } , 250);
    } else {
        window.setTimeout(function() {
            document.getElementById(window.location.hash.slice(1)).scrollIntoView(true);
        } , 250);
    }
}